export const isStockPack = (metricUnit) => String(metricUnit || '').trim().toLowerCase() === 'pack';

export const getStockPackError = ({ metricUnit, unitsPerPack, purchaseMode } = {}) => {
  if (purchaseMode || !isStockPack(metricUnit)) return '';
  const size = Number(unitsPerPack);
  return Number.isSafeInteger(size) && size > 0 && size <= 2147483647
    ? '' : 'Ingresa las unidades por pack como un entero mayor a 0.';
};

export const stockPackLabel = (stock = {}) => ['pack', 'other'].includes(stock.purchaseMode)
  ? `${stock.purchaseSnapshot?.metricUnit || stock.metricUnit} · ${Number(stock.purchaseSnapshot?.weightKg ?? stock.weightKg ?? stock.weight ?? 0).toLocaleString('es-CL', { maximumFractionDigits: 3 })} kg`
  : isStockPack(stock.metricUnit)
  ? `Pack de ${stock.unitsPerPack || '?'} unidades`
  : stock.metricUnit;

export const stockPackTotal = ({ metricUnit, unitsPerPack, quantity } = {}) => {
  if (!isStockPack(metricUnit) || getStockPackError({ metricUnit, unitsPerPack }) || !(Number(quantity) > 0)) return '';
  return `${Number(quantity).toLocaleString('es-CL')} packs × ${Number(unitsPerPack).toLocaleString('es-CL')} unidades = ${(Number(quantity) * Number(unitsPerPack)).toLocaleString('es-CL')} unidades en total.`;
};
